import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const APP_NAME = process.env.VUE_APP_NAME;

// lazy load function
function loadView(view) {
	return () => import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
}

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	linkActiveClass: 'active',
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	routes: [
		{
			path: '/admin/events',
			name: 'AdminEvents',
			component: loadView('AdminEvents'),
			meta: {
				title: `Admin Events - ${APP_NAME}`,
				gtm: 'AdminEvents',
			},
		},
		{
			path: '/admin/users',
			name: 'AdminUsers',
			component: loadView('AdminUsers'),
			meta: {
				title: `Admin Users - ${APP_NAME}`,
				gtm: 'AdminUsers',
			},
		},
		{
			path: '/admin/inactive-users',
			name: 'InactiveUsers',
			component: loadView('InactiveUsers'),
			meta: {
				title: `Inactive Users - ${APP_NAME}`,
				gtm: 'InactiveUsers',
			},
		},
		{
			path: '/admin/clients',
			name: 'AdminClients',
			component: loadView('AdminClients'),
			meta: {
				title: `Admin Clients - ${APP_NAME}`,
				gtm: 'AdminClients',
			},
		},
		{
			path: '/admin/articles',
			name: 'AdminArticles',
			component: loadView('AdminArticles'),
			meta: {
				title: `Admin Articles - ${APP_NAME}`,
				gtm: 'AdminArticles',
			},
		},
		{
			path: '/admin/statistics',
			name: 'AdminStatistics',
			component: loadView('AdminStatistics'),
			meta: {
				title: `Admin Statistics - ${APP_NAME}`,
				gtm: 'AdminStatistics',
			},
		},
		{
			path: '/admin/announcements',
			name: 'Announcements',
			component: loadView('Announcements'),
			meta: {
				title: `Announcements - ${APP_NAME}`,
				gtm: 'Announcements',
			},
		},
		{
			path: '/callback',
			name: 'Callback',
			component: loadView('Callback'),
			meta: {
				title: `Callback - ${APP_NAME}`,
				gtm: 'Callback',
			},
		},
		{
			path: '/login',
			name: 'login',
			component: loadView('Login'),
			meta: {
				title: `Login - ${APP_NAME}`,
				gtm: 'Login',
			},
		},
		{
			path: '/login/sms',
			name: 'LoginSMS',
			component: loadView('LoginSMS'),
			meta: {
				title: `Login SMS - ${APP_NAME}`,
				gtm: 'LoginSMS',
			},
		},
		{
			path: '/events',
			name: 'Events',
			component: loadView('Events'),
			meta: {
				title: `Events - ${APP_NAME}`,
				gtm: 'Events',
			},
		},
		{
			path: '/notifications',
			name: 'Notifications',
			component: loadView('Notifications'),
			meta: {
				title: `Notifications - ${APP_NAME}`,
				gtm: 'Notifications',
			},
		},
		{
			path: '/admin/events/wizard',
			name: 'EventWizard',
			component: loadView('EventWizard'),
			meta: {
				title: `Event Wizard - ${APP_NAME}`,
				gtm: 'EventWizard',
			},
		},
		{
			path: '/events/:eventSlug/now',
			name: 'EventNow',
			component: loadView('EventNow'),
			meta: {
				title: `Now - ${APP_NAME}`,
				gtm: 'EventNow',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/agenda',
			name: 'EventAgenda',
			component: loadView('EventAgenda'),
			meta: {
				title: `Agenda - ${APP_NAME}`,
				gtm: 'EventAgenda',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/details',
			name: 'EventDetails',
			component: loadView('EventDetails'),
			meta: {
				title: `Detail - ${APP_NAME}`,
				gtm: 'EventDetails',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/teams',
			name: 'EventTeam',
			component: loadView('EventTeam'),
			meta: {
				title: `Event Teams - ${APP_NAME}`,
				gtm: 'EventTeam',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/agenda/:agendaSlug/intro-speakers',
			name: 'EventIntroSpeaker',
			component: loadView('EventIntroSpeaker'),
			meta: {
				title: `Intro Speakers - ${APP_NAME}`,
				gtm: 'EventIntroSpeaker',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/agenda/:agendaSlug/materials',
			name: 'EventAgendaMaterials',
			component: loadView('EventAgendaMaterials'),
			meta: {
				title: `Agenda Materials - ${APP_NAME}`,
				gtm: 'EventAgendaMaterials',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/agenda/:agendaSlug/board-advice',
			name: 'EventBoardAdvices',
			component: loadView('EventBoardAdvices'),
			meta: {
				title: `Board Advices - ${APP_NAME}`,
				gtm: 'EventBoardAdvices',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/agenda/:agendaSlug/microphones',
			name: 'EventMicrophones',
			component: loadView('EventMicrophones'),
			meta: {
				title: `Microphones - ${APP_NAME}`,
				gtm: 'EventMicrophones',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/agenda/:agendaSlug/video-ppt',
			name: 'EventVideoPowerPoint',
			component: loadView('EventVideoPowerPoint'),
			meta: {
				title: `Video/Power Point - ${APP_NAME}`,
				gtm: 'EventVideoPowerPoint',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/agenda/:agendaSlug/votings',
			name: 'EventVotings',
			component: loadView('EventVotings'),
			meta: {
				title: `Votings - ${APP_NAME}`,
				gtm: 'EventVotings',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/invitations',
			name: 'EventInvitation',
			component: loadView('EventInvitation'),
			meta: {
				title: `Invitations - ${APP_NAME}`,
				gtm: 'EventInvitation',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/files',
			name: 'EventFiles',
			component: loadView('EventFiles'),
			meta: {
				title: `Files - ${APP_NAME}`,
				gtm: 'EventFiles',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/participants',
			name: 'EventParticipant',
			component: loadView('EventParticipant'),
			meta: {
				title: `Participants - ${APP_NAME}`,
				gtm: 'EventParticipant',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/permissions',
			name: 'EventPermission',
			component: loadView('EventPermission'),
			meta: {
				title: `Permissions - ${APP_NAME}`,
				gtm: 'EventPermission',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/reports',
			name: 'EventReport',
			component: loadView('EventReport'),
			meta: {
				title: `Reports - ${APP_NAME}`,
				gtm: 'EventReport',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/setup-displays',
			name: 'EventSettingDisplay',
			component: loadView('EventSettingDisplay'),
			meta: {
				title: `Setting Display - ${APP_NAME}`,
				gtm: 'EventSettingDisplay',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/setup-displays/:uniqueCode',
			name: 'EventEditDisplay',
			component: loadView('EventEditDisplay'),
			meta: {
				title: `Edit Display - ${APP_NAME}`,
				gtm: 'EventEditDisplay',
			},
			props: true,
		},
		{
			path: '/user/profile',
			name: 'UserProfile',
			component: loadView('UserProfile'),
			meta: {
				title: `User Profile - ${APP_NAME}`,
				gtm: 'UserProfile',
			},
		},
		{
			path: '/privacy-policy',
			name: 'PrivacyPolicy',
			component: loadView('PrivacyPolicy'),
			meta: {
				title: `Privacy Policy - ${APP_NAME}`,
				gtm: 'PrivacyPolicy',
			},
		},
		{
			path: '/events/:eventSlug/speechlist',
			name: 'EventSpeechlist',
			component: loadView('EventSpeechlist'),
			meta: {
				title: `Speech List - ${APP_NAME}`,
				gtm: 'EventSpeechlist',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/suggestions',
			name: 'EventSuggestion',
			component: loadView('EventSuggestion'),
			meta: {
				title: `Suggestions - ${APP_NAME}`,
				gtm: 'EventSuggestion',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/logs',
			name: 'EventLogActivities',
			component: loadView('EventLogActivities'),
			meta: {
				title: `Event Log Activities - ${APP_NAME}`,
				gtm: 'EventLogActivities',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/messages',
			name: 'Messages',
			component: loadView('Messages'),
			meta: {
				title: `Messages - ${APP_NAME}`,
				gtm: 'Messages',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/qr-scanner',
			name: 'EventQRScanner',
			component: loadView('EventQRScanner'),
			meta: {
				title: `Event QR Scanner - ${APP_NAME}`,
				gtm: 'EventQRScanner',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/messages/:id',
			name: 'MessageDetail',
			component: loadView('Messages'),
			meta: {
				title: `Messages - ${APP_NAME}`,
				gtm: 'MessageDetail',
			},
			props: true,
		},
		{
			path: '/password/reset',
			name: 'PasswordReset',
			component: loadView('PasswordReset'),
			meta: {
				title: `Password Reset - ${APP_NAME}`,
				gtm: 'PasswordReset',
			},
		},
		{
			path: '/events/:eventSlug/suggestions-processing',
			name: 'EventSuggestionsProcessing',
			component: loadView('EventSuggestionsProcessing'),
			meta: {
				title: `Suggestions Processing - ${APP_NAME}`,
				gtm: 'EventSuggestionsProcessing',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/medias',
			name: 'EventMedia',
			component: loadView('EventMedia'),
			meta: {
				title: `Media - ${APP_NAME}`,
				gtm: 'EventMedia',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/playback',
			name: 'EventPlayback',
			component: loadView('EventPlayback'),
			meta: {
				title: `Playback - ${APP_NAME}`,
				gtm: 'EventPlayback',
			},
			props: true,
		},
		{
			path: '/displays/:eventSlug/:uniqueCode',
			name: 'EventDisplay',
			component: loadView('EventDisplay'),
			meta: {
				title: `Display Event - ${APP_NAME}`,
				gtm: 'EventDisplay',
			},
			props: true,
		},
		{
			path: '/displays/:eventSlug/:uniqueCode/votings/:votingId',
			name: 'EventDisplayVoting',
			component: loadView('EventDisplay'),
			meta: {
				title: `Display Event - ${APP_NAME}`,
				gtm: 'EventDisplayVoting',
			},
			props: true,
		},
		{
			path: '/displays/:eventSlug/:uniqueCode/votings-display/:votingDisplayNumber',
			name: 'EventDisplayNumberVoting',
			component: loadView('EventDisplay'),
			meta: {
				title: `Display Event - ${APP_NAME}`,
				gtm: 'EventDisplayNumberVoting',
			},
			props: true,
		},
		{
			path: '/displays/:eventSlug/:uniqueCode/suggestions/:suggestionId',
			name: 'EventDisplaySuggestion',
			component: loadView('EventDisplay'),
			meta: {
				title: `Display Event - ${APP_NAME}`,
				gtm: 'EventDisplaySuggestion',
			},
			props: true,
		},
		{
			path: '/displays/:eventSlug/:uniqueCode/:displayNumber',
			name: 'EventDisplayNumberSuggestion',
			component: loadView('EventDisplay'),
			meta: {
				title: `Display Event - ${APP_NAME}`,
				gtm: 'EventDisplayNumberSuggestion',
			},
			props: true,
		},
		{
			path: '/displays/:eventSlug/:uniqueCode/playback/:playbackSlug',
			name: 'EventDisplayPlayback',
			component: loadView('EventDisplay'),
			meta: {
				title: `Display Event - ${APP_NAME}`,
				gtm: 'EventDisplayPlayback',
			},
			props: true,
		},
		{
			path: '/displays/:eventSlug/:uniqueCode/playback/:playbackSlug/bookmark/:bookmarkId',
			name: 'EventDisplayPlaybackBookmark',
			component: loadView('EventDisplay'),
			meta: {
				title: `Display Event - ${APP_NAME}`,
				gtm: 'EventDisplayPlaybackBookmark',
			},
			props: true,
		},
		{
			path: '/feedbacks',
			name: 'Feedbacks',
			component: loadView('Feedbacks'),
			meta: {
				title: `Feedbacks - ${APP_NAME}`,
				gtm: 'Feedbacks',
			},
		},
		{
			path: '/events/:eventSlug/statuses',
			name: 'EventStatus',
			component: loadView('EventStatus'),
			meta: {
				title: `Event Status - ${APP_NAME}`,
				gtm: 'EventStatus',
			},
			props: true,
		},
		{
			path: '/login/auto_login',
			name: 'AutoLogin',
			component: loadView('AutoLogin'),
			meta: {
				title: `Auto Login - ${APP_NAME}`,
				gtm: 'AutoLogin',
			},
			props: true,
		},
		{
			path: '/terms',
			name: 'Terms',
			component: loadView('Terms'),
			meta: {
				title: `Terms - ${APP_NAME}`,
				gtm: 'Terms',
			},
		},
		{
			path: '/support',
			name: 'Support',
			component: loadView('Support'),
			meta: {
				title: `Support - ${APP_NAME}`,
				gtm: 'Support',
			},
		},
		{
			path: '/events/:eventSlug/video-stream',
			name: 'EventVideoStream',
			component: loadView('EventVideoStream'),
			meta: {
				title: `Video Stream - ${APP_NAME}`,
				gtm: 'EventVideoStream',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/channels',
			name: 'EventChannel',
			component: loadView('EventChannel'),
			meta: {
				title: `Channels - ${APP_NAME}`,
				gtm: 'EventChannel',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/chats',
			name: 'EventChat',
			component: loadView('EventChat'),
			meta: {
				title: `Chats - ${APP_NAME}`,
				gtm: 'EventChat',
			},
			props: true,
		},
		{
			path: '/theme',
			name: 'Theme',
			component: loadView('Theme'),
			meta: {
				title: `Theme - ${APP_NAME}`,
				gtm: 'Theme',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/theme',
			name: 'EventTheme',
			component: loadView('EventTheme'),
			meta: {
				title: `Theme - ${APP_NAME}`,
				gtm: 'EventTheme',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/leave',
			name: 'EventLeave',
			component: loadView('EventLeave'),
			meta: {
				title: `Leave - ${APP_NAME}`,
				gtm: 'EventLeave',
			},
			props: true,
		},
		{
			path: '/admin/user-manuals',
			name: 'AdminUserManuals',
			component: loadView('AdminUserManuals'),
			meta: {
				title: `Theme - ${APP_NAME}`,
				gtm: 'AdminUserManuals',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug/landing-page',
			name: 'EventLandingPage',
			component: loadView('EventLandingPage'),
			meta: {
				title: `Landing Page - ${APP_NAME}`,
				gtm: 'EventLandingPage',
			},
			props: true,
		},
		{
			path: '/events/:eventSlug',
			name: 'LandingPage',
			component: loadView('Events/LandingPage'),
			meta: {
				title: `Landing Page - ${APP_NAME}`,
				gtm: 'LandingPage',
			},
			props: true,
		},
	],
});
